import script from "./EmptyValueDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyValueDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyValueDisplay.vue?vue&type=style&index=0&id=ad9f387a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad9f387a"]])

export default __exports__